import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { getRelativeDate, renderNullCase } from '@helper/utils';
import { IStatCardGroupProps } from '.';

export const StatCardGroup = ({ title, items, onEditClick }: IStatCardGroupProps): ReactElement => {
	return (
		<div className="stats-card-wrapper">
			{title && <div className="title-with-line">{title}</div>}
			<ul className="row">
				{items.map((item) => (
					<li key={item.label} className="d-col d-col-6">
						<span>
							<span className="h5">{item.label}</span>
							{item.value !== null && item.value !== undefined ? (
								<span className="h3">
									{typeof item.value === 'number' && !Number.isInteger(item.value) ? item.value.toFixed(2) : item.value}{' '}
									{item.unit}
									{item.showEditIcon && item.editPath && (
										<NavLink to={item.editPath} onClick={onEditClick} aria-label="Edit">
											<span className="icon-edit"></span>
										</NavLink>
									)}
								</span>
							) : (
								renderNullCase('h3 just-center')
							)}

							{item.lastModifiedDate && (
								<span className="h5 smalltext">(Last edited {getRelativeDate(String(item.lastModifiedDate))})</span>
							)}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
};
